import React from 'react';
import { SelectInput } from 'react-admin';

const categoryChoices = [
    { id: 'lab', name: 'Lab' },
    { id: 'marketing', name: 'Marketing' },
    { id: 'infra', name: 'Infra' },
    { id: 'sales', name: 'Sales' },
    { id: 'people', name: 'People' },
    { id: 'strategy', name: 'Strategy' }
];

const CategoryInput = (props) => (
    <SelectInput
        source="category"
        choices={categoryChoices}
        {...props}
    />
);

export default CategoryInput;
